import moment from 'moment';
import { isEmpty } from 'ramda';
import { push } from 'react-router-redux';

import * as t from './actionTypes';

const loading = type => ({
  type,
});

const loadById = flightId => async (dispatch, getStore, client) => {
  dispatch(loading(t.LOAD_BY_ID));

  try {
    const result = await client.get(`/flight/${flightId}`);

    return dispatch({
      type: t.LOAD_BY_ID_SUCCESS,
      result,
    });
  } catch (error) {
    return dispatch({
      type: t.LOAD_FAIL,
      error,
    });
  }
};

const loadExtendedDetailsByCarrierFlightNumberAndDate = ({
  carrier, flightNumber, year, month, day, flightId,
}) => {
  let y = year;
  let m = month;
  let d = day;

  if (!year || !month || !day) {
    const now = moment();
    y = now.year();
    m = now.month() + 1;
    d = now.date();
  }

  const url = flightId ? `/extendedDetails/${carrier}/${flightNumber}/${y}/${m}/${d}/${flightId}` : `/extendedDetails/${carrier}/${flightNumber}/${y}/${m}/${d}`;

  return async (dispatch, getStore, client) => {
    dispatch(loading(t.LOAD_EXTENDED_DETAILS_BY_CARRIER_FLIGHT_NUMBER_AND_DATE));

    try {
      const result = await client.get(url);

      dispatch({
        type: t.LOAD_EXTENDED_SUCCESS,
        result,
      });
    } catch (error) {
      dispatch({ type: t.LOAD_FAIL });
    }
  };
};

const loadByCarrierFlightNumberAndDate = ({
  carrier, flightNumber, year, month, day, hour,
}) => {
  let y = year;
  let m = month;
  let d = day;

  if (!year || !month || !day) {
    const now = moment();
    y = now.year();
    m = now.month() + 1;
    d = now.date();
  }

  const url = hour ? `/flight/${carrier}/${flightNumber}/${y}/${m}/${d}/${hour}` : `/flight/${carrier}/${flightNumber}/${y}/${m}/${d}`;

  return async (dispatch, getStore, client) => {
    dispatch(loading(t.LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE));

    try {
      const result = await client.get(url);

      if (isEmpty(result)) {
        const noResultsUrl = '/flight-tracker/search/advanced?error=FLIGHT_LOAD_ERROR2';
        dispatch(push(noResultsUrl));
      }

      return dispatch({
        type: t.LOAD_BY_CARRIER_FLIGHT_NUMBER_AND_DATE_SUCCESS,
        result,
      });
    } catch (error) {
      return dispatch({
        type: t.LOAD_FAIL,
        error,
      });
    }
  };
};

const updateSegments = segments => ({
  type: t.UPDATE_SEGMENTS,
  segments,
});

const setSingleFlightSecondarySearchAction = bool => ({
  type: t.SET_SECONDARY_SEARCH_ACTION,
  bool,
});

export {
  loadById,
  loadByCarrierFlightNumberAndDate,
  loadExtendedDetailsByCarrierFlightNumberAndDate,
  setSingleFlightSecondarySearchAction,
  updateSegments,
};



// WEBPACK FOOTER //
// ./modules/SingleFlight/redux/actions.js